<script>
import ExactSearch from "@/mixins/exactSearch";
export default {
  mixins: [ExactSearch],
  props: ["AllWorkType", "AllOperateType"],
  beforeCreate() {
    this.fields = [
      "granteeCode",
      "purviewCode",
      "createUser",
      "workType",
      "operateType",
    ];
  },
  methods: {
    getFieldTpls(model) {
      model.granteeCode = _.trim(model.granteeCode);
      model.purviewCode = _.trim(model.purviewCode);
      const tpls = {
        granteeCode: (
          <el-form-item label-width="100px" title={this.$t('language.5o6u3wttjm00')} label={this.$t('language.5o6u3wttjm00')}>
            <el-input
              v-model_trim={model.granteeCode}
              placeholder={this.$t('language.5o6u3wttk6k0')}
              clearable
            />
            <el-tooltip class="operation-log-tooltip" effect="dark" content={this.$t('language.5o6u3wtti1k0')} placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </el-form-item>
        ),
        purviewCode: (
          <el-form-item label-width="100px" title={this.$t('language.5o6u3wttk1c0')} label={this.$t('language.5o6u3wttk1c0')}>
            <el-input
              v-model_trim={model.purviewCode}
              placeholder={this.$t('language.5o6u3wttk6k0')}
              clearable
            />
          </el-form-item>
        ),
        createUser: (
          <el-form-item label-width="100px" title={this.$t('language.5o6u3wttkdw0')} label={this.$t('language.5o6u3wttkdw0')}>
            <el-input
              v-model_trim={model.createUser}
              placeholder={this.$t('language.5o6u3w5ti1k0')}
              clearable
            />
          </el-form-item>
        ),
        workType: (
          <el-form-item label-width="100px" title={this.$t('language.5o6u3wttjuo0')} label={this.$t('language.5o6u3wttjuo0')}>
            <el-select
              v-model={model.workType}
              placeholder={this.$t('language.5o6u3wttk3k0')}
              filterable
              clearable
            >
              {this.AllWorkType.map((item) => {
                return (
                  <el-option
                    value={item.workType}
                    label={item.workName}
                  ></el-option>
                );
              })}
            </el-select>
          </el-form-item>
        ),
        operateType: (
          <el-form-item label-width="100px" title={this.$t('language.5o6u3wttjxs0')} label={this.$t('language.5o6u3wttjxs0')}>
            <el-select
              v-model={model.operateType}
              placeholder={this.$t('language.5o6u3ottk6k0')}
              filterable
              clearable
            >
              {this.AllOperateType.map((item) => {
                return (
                  <el-option
                    value={item.operateType}
                    label={item.operateName}
                  ></el-option>
                );
              })}
            </el-select>
          </el-form-item>
        ),
      };
      return tpls;
    },
  },
};
</script>
<style lang="scss">
.operation-log-tooltip {
  color: #666666;
  position: absolute;
  right: -22px;
  top: 50%;
  margin-top: -7px;
}
</style>
